import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

mapboxgl.accessToken = 'pk.eyJ1IjoiZ2d5eS0xOTk4IiwiYSI6ImNrdGkxZDlvYTA3eGIydG1zcHJhNHM0ZGoifQ.js1d4eYpNBlvIvgh07mtXw'

export default mapboxgl
